<template>
  <div :class="[multipage === true ? 'multi-page' : 'single-page', 'home-page']">
    <a-row :gutter="7" class="head-info">
      <a-col :span="24">
        <a-card class="head-info-card" style="border-radius: 10px;">
          <a-col :span="12">
            <div class="head-info-avatar">
              <!-- <img alt="头像" :src="avatar"> -->
              <a-avatar
                v-if="isAvatat(user.avatar)"
                class="avatar"
                shape="square"
                :size="64"
                :src="user.avatar"
              />
              <a-avatar
                v-else
                shape="square"
                :size="64"
                style="color: #fff;backgroundColor: #1890ff;font-size:x-large;"
              >{{ cutUserName(user.username) }}</a-avatar>
            </div>
            <div class="head-info-count">
              <div class="head-info-welcome">{{ topObjData.welcomeMessage }}</div>
              <div class="head-info-desc">
                <p>{{ user.deptName ? user.deptName : '暂无部门' }} | {{ user.roleName ? user.roleName : '暂无角色' }}</p>
              </div>
              <div
                class="head-info-time"
              >上次登录时间：{{ user.lastLoginTime ? user.lastLoginTime : '第一次访问系统' }}</div>
            </div>
          </a-col>
          <a-col :span="12">
            <div>
              <a-row class="more-info">
                <a-col :span="4" />
                <a-col :span="2" />
                <a-col :span="2" />
                <a-col :span="6">
                  <div style="display: flex;">
                    <div>
                      <a-icon type="user" style="color: #9C71FE; font-size: 20px;" />
                    </div>
                    <div>
                      <head-info
                        title="今日IP"
                        :content="topObjData.todayIp"
                        :center="false"
                        :bordered="false"
                      />
                    </div>
                  </div>
                </a-col>
                <a-col :span="6">
                  <div style="display: flex;">
                    <div>
                      <a-icon type="user" style="color: #80B7F9;  font-size: 20px;" />
                    </div>
                    <div>
                      <head-info
                        title="今日访问"
                        :content="topObjData.todayVisitCount"
                        :center="false"
                        :bordered="false"
                      />
                    </div>
                  </div>
                </a-col>
                <a-col :span="4">
                  <div style="display: flex;">
                    <div>
                      <a-icon type="team" style="color: #F85F69; font-size: 20px;" />
                    </div>
                    <div>
                      <head-info
                        title="总访问量"
                        :content="topObjData.totalVisitCount"
                        :center="false"
                      />
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
          </a-col>
        </a-card>
      </a-col>
    </a-row>
    <component :isChild="true" :is="getComponet" />
    <!-- <adminHomeVue/>
     <financeHomeVue v-else-if="isFinance"/>
      <marketHomeVue v-else-if="isMarket"/>
      <synthesizeHomeVue v-else-if="isSynthensize"/>
      <departmentHomeVue v-else-if="isDpartmen"/>
    <personHomeVue v-else/>-->
  </div>
</template>
<script>
// import VueGridLayout from 'vue-grid-layout'
// 模块引入
// import approveVue from '@/components/homeComponents/approve.vue' // 审批
// import briefingBoardVue from '@/components/homeComponents/briefingBoard.vue' // 简报看板
// import contractInfoVue from '@/components/homeComponents/contractInfo.vue' // 合同订单统计图表
// import expenseReimInfoVue from '@/components/homeComponents/expenseReimInfo.vue' // 待支取费用报销
// import internalAnnouncementVue from '@/components/homeComponents/internalAnnouncement.vue' // 内部公告
// import invoiceListVue from '@/components/homeComponents/invoiceList.vue' // 回款未开票列表
// import paymentPlanChartVue from '@/components/homeComponents/paymentPlanChart.vue' // 付款计划统计
// import receivableInfoVue from '@/components/homeComponents/receivableInfo.vue' // 应收款统计图表
// import returnMoneyInfoVue from '@/components/homeComponents/returnMoneyInfo.vue' // 回款统计图表
// import projectInfoVue from '@/components/projectStatis/index.vue' // 项目统计图表
// import customerVue from '@/components/projectStatis/customerKanBan.vue' // 项目统计图表
import HeadInfo from '@/views/common/HeadInfo'

import adminHomeVue from './roleHome/adminHome.vue'
import financeHomeVue from './roleHome/financeHome.vue'
import marketHomeVue from './roleHome/marketHome.vue'
import synthesizeHomeVue from './roleHome/synthesizeHome.vue'
import departmentHomeVue from './roleHome/departmentHome.vue'
import personHomeVue from './roleHome/personHome.vue'

import { isAvatat, cutUserName } from '@/utils/index'
import { mapState, mapMutations } from 'vuex'
import moment from 'moment'
moment.locale('zh-cn')

export default {
  name: 'HomePage',
  components: {
    adminHomeVue,
    financeHomeVue,
    marketHomeVue,
    synthesizeHomeVue,
    departmentHomeVue,
    personHomeVue,
    HeadInfo
  },
  data () {
    return {
      moment,
      topObjData: {},
      AdministratorLayout: [
        { 'x': 0, 'y': 0, 'w': 2, 'h': 2, 'i': '0', title: '审批管理', component: 'approveVue' },
        { 'x': 2, 'y': 0, 'w': 2, 'h': 4, 'i': '1', title: '简报看板', component: 'briefingBoardVue' },
        { 'x': 4, 'y': 1, 'w': 2, 'h': 5, 'i': '2', title: '合同统计', component: 'contractInfoVue' },
        { 'x': 6, 'y': 1, 'w': 2, 'h': 3, 'i': '3', title: '回款统计', component: 'returnMoneyInfoVue' },
        { 'x': 8, 'y': 2, 'w': 2, 'h': 3, 'i': '4', title: '应收款统计', component: 'receivableInfoVue' },
        { 'x': 10, 'y': 3, 'w': 2, 'h': 3, 'i': '5', title: '项目统计', component: 'projectInfoVue' }
      ],
      publicDictData: {
        returnedMoneyTypeList: [],
        returnedMoneyTypeObj: {},
        paymentMethodList: [],
        paymentMethodObj: {},
        billTypeList: [],
        billTypeObj: {},
        advanceTypeList: [],
        advanceTypeObj: {},
        prepayTypeList: [],
        prepayTypeObj: {},
        costTypeList: [],
        costTypeObj: {},
        comAccountList: [],
        comAccountObj: {},
        subsidiaryList: [],
        subsidiaryObj: {},
        receiptsTypeList: [],
        receiptsTypeObj: {},
        contractSubTypeList: [],
        contractSubTypeObj: {},
        customerTypeList: [],
        customerTypeObj: {},
        dimissionTypeList: [],
        dimissionTypeObj: {},
        resignationsLinkNameTypeList: [],
        resignationsLinkNameTypeObj: {},
        supplierTypeList: [],
        supplierTypeObj: {},
        projectPhaseList: [],
        projectPhaseObj: {},
        projectStatusList: [],
        projectTypeList: [],
        signExpectationList: [],
        linkNameTypeList: [],
        linkNameTypeObj: {},
        paymentTypeList: [],
        paymentTypeObj: {},
        noticeTypeList: [],
        noticeTypeObj: {},
        projectPersonList: [],
        projectPersonObj: {},
        cgTypeList: [],
        cgTypeObj: {},
        extraPayTypeList: [],
        extraPayTypeObj: {},
        workOutTypeList: [],
        workOutTypeObj: {},
        overtimeTypeList: [],
        overtimeTypeObj: {},
        feesChargesTypeList: [],
        feesChargesTypeObj: {},
        returnedMoneyMethodsList: [],
        returnedMoneyMethodsObj: {},
        personnelCostTypeList: [],
        personnelCostTypeObj: {},
        groudNameWifiList: [],
        groudNameWifiObj: {},
        checkStatusList: [],
        checkStatusObj: {},
        fundCostTypeList: [],
        fundCostTypeObj: {},
        storageLocationList: [],
        storageLocationObj: {},
        outcarObj: {},
        outcarList: [],
        unitList: [],
        unitObj: {}
      }
    }
  },
  computed: {
    ...mapState({
      multipage: state => state.setting.multipage,
      user: state => state.account.user,
      permissions: state => state.account.permissions
    }),
    avatar () {
      return `static/avatar/${this.user.avatar}`
    },
    getComponet () {
      // console.log(this.permissions, '======================')
      // let roleIdStr = this.user.roleId
      // let roleIdStr = '4'
      // let newRoleId = ''
      // if (roleIdStr !== null && roleIdStr !== '') {
      //   if (roleIdStr.includes(',')) { // 多重权限
      //     // let arr = ['1', '8', '12', '4', '17'] // 钉钉-角色数组
      //     let arr = ['17', '4', '12', '8', '1']
      //     // let arr = [ '3928017485', '3928017484', '18b8ed7e668ec4c2b66a492a76e4b070', '4' ] // 本地测试库-角色数组
      //     let idArr = roleIdStr.split(',')
      //     for (const num of idArr) {
      //       if (num === '1') {
      //         newRoleId = num
      //         break
      //       } else {
      //         if (arr.includes(num)) {
      //           newRoleId = num
      //         }
      //       }
      //     }
      //     // 数组循环
      //     // idArr.forEach(id => {
      //     //   if (arr.includes(id)) {
      //     //     newRoleId = id
      //     //   }
      //     // })
      //   } else {
      //     newRoleId = roleIdStr
      //   }
      // }
      // switch (newRoleId) {
      //   case '1':
      //   case '3928017485': // 管理员
      //   case '3928017484': // 总经理
      //     return (resolve) => require(['@/views/roleHome/adminHome.vue'], resolve)
      //   case '18b8ed7e668ec4c2b66a492a76e4b070': // 财务人员
      //     return (resolve) => require(['@/views/roleHome/financeHome.vue'], resolve)
      //   case '4': // 部门主管
      //     return (resolve) => require(['@/views/roleHome/departmentHome.vue'], resolve)
      //   default:
      //     return (resolve) => require(['@/views/roleHome/personHome.vue'], resolve)
      // }
      // switch (newRoleId) {
      //   case '1': // 管理员
      //     // case '23': // 总经理
      //     return (resolve) => require(['@/views/roleHome/adminHome.vue'], resolve)
      //   case '8': // 财务人员
      //     return (resolve) => require(['@/views/roleHome/financeHome.vue'], resolve)
      //   case '12': // 行政人员
      //     return (resolve) => require(['@/views/roleHome/synthesizeHome.vue'], resolve)
      //   case '4': // 销售人员
      //     return (resolve) => require(['@/views/roleHome/marketHome.vue'], resolve)
      //   case '17': // 部门主管
      //     return (resolve) => require(['@/views/roleHome/departmentHome.vue'], resolve)
      //   default:
      //     return (resolve) => require(['@/views/roleHome/personHome.vue'], resolve)
      // }
      const permissions = this.permissions
      if (permissions.includes('adminHome')) {
        // console.log('adminHome')
        return (resolve) => require(['@/views/roleHome/adminHome.vue'], resolve)
      } else if (permissions.includes('financeHome')) {
        // console.log('financeHome')
        return (resolve) => require(['@/views/roleHome/financeHome.vue'], resolve)
      } else if (permissions.includes('synthesizeHome')) {
        // console.log('synthesizeHome')
        return (resolve) => require(['@/views/roleHome/synthesizeHome.vue'], resolve)
      } else if (permissions.includes('marketHome')) {
        // console.log('marketHome')
        return (resolve) => require(['@/views/roleHome/marketHome.vue'], resolve)
      } else if (permissions.includes('departmentHome')) {
        // console.log('departmentHome')
        return (resolve) => require(['@/views/roleHome/departmentHome.vue'], resolve)
      } else {
        // console.log('personHome')
        return (resolve) => require(['@/views/roleHome/personHome.vue'], resolve)
      }
    }
  },
  activated () {
    this.$set(this.topObjData, 'welcomeMessage', this.welcomeData())
    this.getHomeData()
  },
  mounted () {
    this.getDictData()
    this.$set(this.topObjData, 'welcomeMessage', this.welcomeData())
    this.getHomeData()
  },
  methods: {
    isAvatat,
    cutUserName,
    getHomeData () {
      this.$get(`index/${this.user.username}`).then((r) => {
        const data = r.data.data
        // 今日IP、今日访问、总访问量
        this.$set(this.topObjData, 'todayIp', data.todayIp)
        this.$set(this.topObjData, 'todayVisitCount', data.todayVisitCount)
        this.$set(this.topObjData, 'totalVisitCount', data.totalVisitCount)
      }).catch((r) => {
        this.$message.error('获取首页信息失败')
      })
    },
    setPublicDictData (dictTypeEn, dictList, dictObj) {
      return new Promise((resolve, reject) => {
        this.$get('/common/dict/getListByEn', { dictTypeEn: dictTypeEn }).then(res => {
          if (res.data.status === 1) {
            let resData = res.data.data
            resData.forEach(item => {
              this.publicDictData[dictList].push({
                label: item.dictCode,
                value: item.dictName,
                parentEn: dictTypeEn,
                listVal: dictList,
                objVal: dictObj
              })
            })
            if (dictObj) {
              resData.forEach(item => {
                this.publicDictData[dictObj][item.dictCode] = item.dictName
              })
            }
            resolve(this.publicDictData)
          } else {
            reject(res.data.msg)
          }
        })
      })
    },
    welcomeData () {
      const date = new Date()
      const hour = date.getHours()
      const time = hour < 6 ? '早上好' : (hour <= 11 ? '上午好' : (hour <= 13 ? '中午好' : (hour <= 18 ? '下午好' : '晚上好')))
      // let welcomeArr = [
      //   '喝杯咖啡休息下吧☕',
      //   '要不要和朋友打局LOL',
      //   '要不要和朋友打局王者荣耀',
      //   '几天没见又更好看了呢😍',
      //   '今天又写了几个Bug🐞呢',
      //   '今天在群里吹水了吗',
      //   '今天吃了什么好吃的呢',
      //   '今天您微笑了吗😊',
      //   '今天帮助别人解决问题了吗',
      //   '准备吃些什么呢',
      //   '周末要不要去看电影？'
      // ]
      // let index = Math.floor((Math.random() * welcomeArr.length))
      // return `${time}，${this.user.username}，${welcomeArr[index]}`
      return `${time}！${this.user.username}`
    },
    ...mapMutations({
      setPurchaseDictData: 'account/setPurchaseDictData',
      setDictData: 'account/setDictData'
    }),
    getDictData () {
      // 循环存取字典数据
      Promise.all([
        this.setPublicDictData('purchase_type', 'cgTypeList', 'cgTypeObj'), // 采购分类
        this.setPublicDictData('purchase_costType', 'extraPayTypeList', 'extraPayTypeObj'), // 采购附加费用分类
        this.setPublicDictData('returnedMoney_type', 'returnedMoneyTypeList', 'returnedMoneyTypeObj'), // 回款类别
        this.setPublicDictData('returnedMoney_paymentMethod', 'paymentMethodList', 'paymentMethodObj'), // 付款方式
        this.setPublicDictData('purchase_paymentType', 'paymentTypeList', 'paymentTypeObj'), // 付款记录分类
        this.setPublicDictData('office_noticeType', 'noticeTypeList', 'noticeTypeObj'), // 内部公告分类
        this.setPublicDictData('billingRecord_billType', 'billTypeList', 'billTypeObj'), // 票据类型
        this.setPublicDictData('finance_advanceType', 'advanceTypeList', 'advanceTypeObj'), // 预支类型
        this.setPublicDictData('finance_prepayType', 'prepayTypeList', 'prepayTypeObj'), // 预付类型
        this.setPublicDictData('finance_costType', 'costTypeList', 'costTypeObj'), // 费用报销类别
        this.setPublicDictData('returnedMoney_comAccount', 'comAccountList', 'comAccountObj'), // 公司账户
        this.setPublicDictData('contract_type', 'receiptsTypeList', 'receiptsTypeObj'), // 合同分类
        this.setPublicDictData('contract_subType', 'contractSubTypeList', 'contractSubTypeObj'), // 合同类型细分
        this.setPublicDictData('client_type', 'customerTypeList', 'customerTypeObj'), // 客户种类
        this.setPublicDictData('client_resignationsCompensation', 'dimissionTypeList', 'dimissionTypeObj'), // 离职补偿人员种类
        this.setPublicDictData('client_resignationsLinkName', 'resignationsLinkNameTypeList', 'resignationsLinkNameTypeObj'), // 离职补偿人员联系人分类类
        this.setPublicDictData('client_supplierType', 'supplierTypeList', 'supplierTypeObj'), // 供应商类型
        this.setPublicDictData('project_stage', 'projectPhaseList', 'projectPhaseObj'), // 项目阶段
        this.setPublicDictData('project_type', 'projectTypeList'), // 项目类型
        this.setPublicDictData('project_status', 'projectStatusList'), // 项目状态
        this.setPublicDictData('project_subsidiary', 'subsidiaryList', 'subsidiaryObj'), // 下属公司 2695
        this.setPublicDictData('project_signExpectation', 'signExpectationList'), // 签单预期
        this.setPublicDictData('linkman_type', 'linkNameTypeList', 'linkNameTypeObj'), // 联系人类型
        this.setPublicDictData('expenseReim_projectPerson', 'projectPersonList', 'projectPersonObj'), // 项目负责人-费用报销新建
        this.setPublicDictData('workOutType', 'workOutTypeList', 'workOutTypeObj'), // 外出类型
        this.setPublicDictData('outcar', 'outcarList', 'outcarObj'), // 外出类型
        this.setPublicDictData('overtimeType', 'overtimeTypeList', 'overtimeTypeObj'), // 加班
        this.setPublicDictData('feesChargesType', 'feesChargesTypeList', 'feesChargesTypeObj'), // 经营成本-费用类别
        this.setPublicDictData('returnedMoney_Methods', 'returnedMoneyMethodsList', 'returnedMoneyMethodsObj'), // 回款方式
        this.setPublicDictData('personnelCost_type', 'personnelCostTypeList', 'personnelCostTypeObj'), // 人员成本类型
        this.setPublicDictData('groudNameWifi', 'groudNameWifiList', 'groudNameWifiObj'), // 考勤wifi类型
        this.setPublicDictData('checkStatus', 'checkStatusList', 'checkStatusObj'), // 审核状态
        this.setPublicDictData('fundCostType', 'fundCostTypeList', 'fundCostTypeObj'), // 项目资金管理方式
        this.setPublicDictData('storageLocation', 'storageLocationList', 'storageLocationObj'), // 存放地点
        this.setPublicDictData('unit', 'unitList', 'unitObj') // 单位
      ]).catch(e => {
        this.$message.warning(e)
      }).finally(r => {
        // 存取到vuex
        this.setDictData(this.publicDictData)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.home-page {
  .head-info {
    margin-bottom: 0.5rem;

    .head-info-card {
      padding: 0rem;
      border-color: #f1f1f1;

      .head-info-avatar {
        display: inline-block;
        float: left;
        margin-right: 1rem;

        img {
          width: 5rem;
          border-radius: 2px;
        }
      }

      .head-info-count {
        display: inline-block;
        float: left;

        .head-info-welcome {
          font-size: 16px;
          margin-bottom: 4px;
        }

        .head-info-desc {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
          padding: 2px 0;

          p {
            margin-bottom: 0;
          }
        }

        .head-info-time {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
          padding: 2px 0;
        }
      }
      /deep/.more-info {
        svg {
          font-size: 26px !important;
        }
      }
    }
  }

  .count-info {
    display: flex;
    margin-top: 1.6rem;
  }

  a {
    color: black;
  }

  .panel {
    padding-bottom: 0.6rem;
    background-color: #fff;
    border: 1px solid transparent;
    border-radius: 10px;

    .panel-title {
      width: 100%;
      border-bottom: solid 1px #e9e9e9;
      line-height: 50px;
      padding-left: 15px;
      position: relative;

      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 30px;
        background-color: #0079fe;
        position: absolute;
        left: 0;
        top: 10px;
        border-radius: 4px;
      }

      span {
        &:first-child {
          font-size: 18px !important;
          font-weight: 400;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue